import { inject } from '@angular/core';
import { Router, CanActivateChildFn, CanActivateFn } from '@angular/router';
import { ApiService } from './api.service';

function checkAuth() {
  const apiService = inject(ApiService);
  const router = inject(Router);

  if (apiService.isAuthenticated()) {
    return true;
  }

  router.navigate(['/login'], { queryParams: { expired: '1' } });
  return false;
}

export const authGuard: CanActivateFn = () => checkAuth();
export const authChildGuard: CanActivateChildFn = () => checkAuth();

export const landingGuard: CanActivateFn = () => {
  const apiService = inject(ApiService);
  const router = inject(Router);
  return apiService.isAuthenticated()
    ? router.createUrlTree(['/admin/dashboard'])
    : router.createUrlTree(['/login']);
};

export const guestGuard: CanActivateFn = () => {
  const apiService = inject(ApiService);
  const router = inject(Router);
  return apiService.isAuthenticated()
    ? router.createUrlTree(['/admin/dashboard'])
    : true;
};

export const officeArchiveGuard: CanActivateFn = () => {
  const apiService = inject(ApiService);
  const router = inject(Router);
  if (!apiService.isAuthenticated()) {
    return router.createUrlTree(['/login'], { queryParams: { expired: '1' } });
  }
  if (!['Admin', 'Dispatcher', 'Manager'].includes(apiService.currentUser()?.role || '')) {
    return router.createUrlTree(['/admin/dashboard']);
  }
  return true;
};
